import styled from 'styled-components'

export const ContentWrapper = styled.div`
  justify-content: center;
  text-align: justify;

  border: 0 1px 0 1px #7444ff dotted;
  line-height: 1.9;

  pre {
    padding: 16px;
    border-radius: 4px;
    overflow: auto;
    font-size: 14px;
    margin-bottom: 1.5rem;
    margin-top: 0.8rem;
    padding: 1.7rem 0 1.6rem 0.4rem;
    border-radius: 12px;
    overflow: hidden;
    background-image: url(/images/window-buttons.png);
    background-color: rgb(40, 42, 54);
    background-repeat: no-repeat;
    background-size: 44px 10px;
    background-position: 16px 14px;
  }
  p > code,
  li > code {
    color: #e02424;
    padding: 1px 5px;
    background: #eee;
    text-shadow: none;
    border-radius: 2px;
  }

  p {
    margin-bottom: 1.5em;
  }

  ul {
    list-style: none;
    margin: revert;
    padding: revert;

    li {
      margin: revert;
      padding: revert;
      max-width: 600px;
      position: relative;
    }

    a {
      max-width: 500px;
      position: relative;
      color: #9e7cff;
      display: block;
      cursor: pointer;
      padding: 0px 25px;
      margin: 0px 5px;

      &:before {
        content: '';
        width: 10px;
        height: 10px;
        background-color: #8358ff;
        position: absolute;
        border-radius: 50%;
        left: 10px;
        top: 0;
        bottom: 0;
        margin: auto;
      }
      &:hover {
        box-shadow: 0 8px 15px rgb(66 139 202 / 0.55);
        background: #b9a0ff;
        color: #131740;
        border-radius: 5px;
      }
      &:hover:before {
        box-shadow: 0 8px 15px rgb(66 139 202 / 0.55);
        background: #ffffff;
        color: #131740;
      }
    }
  }

  h2 {
    font-size: 1.5rem;
    margin-top: 1em;
    margin-bottom: 1em;
    line-height: 1.3333333;
    text-align: left;
    text-shadow: 3px 3px 3px #a1a2b3;
    text-transform: capitalize;
    color: #7444ff;
  }

  h3 {
    font-size: 0.98rem;
    margin-top: 1em;
    margin-bottom: 1em;
    line-height: 1.3333333;
    text-align: left;
    text-shadow: 1px 3px 3px #a1a2b3;
    text-transform: capitalize;
    color: #7444ff;
  }

  :is(.dark h2, h3) {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
      var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    text-shadow: none;
  }
`
